/*
 * The migrated taskpane header mirrors the portal brand treatment while keeping
 * live account data truthful: plan name appears when logged in, and language
 * remains the only persistent control.
 */

import { useTranslation } from "../i18n/useTranslation";
import { useStore } from "../state/store";
import { formatSubscriptionPlanLabel } from "../state/subscriptionLabels";

export function Header(): JSX.Element {
  const { t, lang, toggleLang } = useTranslation();
  const subscription = useStore((s) => s.subscription);
  const authState = useStore((s) => s.authState);

  const planLabel = formatSubscriptionPlanLabel(subscription, {
    free: t.tokenPickerNoPlan,
    families: t.planFamilies,
    tiers: t.planTiers,
  });

  const renderPlanChip = () => {
    if (authState !== "logged-in") return null;

    return (
      <button type="button" className="header-pill header-pill--plan" aria-label={planLabel}>
        <span className="header-pill__dot" />
        {planLabel}
      </button>
    );
  };

  return (
    <header className="app-header" aria-label={t.appTitle}>
      <div className="app-header__brand">
        <span className="app-header__mark" aria-hidden="true">S</span>
        <span className="app-header__title">{t.appTitle}</span>
      </div>
      <div className="app-header__actions">
        {renderPlanChip()}
        <button type="button" className="header-pill header-pill--language" onClick={toggleLang} aria-label="Change language">
          {lang === "en" ? "EN" : "EL"}
        </button>
      </div>
    </header>
  );
}
